import React from 'react';
import _ from 'lodash';
import TabContainer from '../../../../../../common/components/tab/containers/tab.containers';
import AccountLedgerBasicInfoComponent from './account-ledger-basic-info.component';
import AccountLedgerTaxInfoComponent from './account-ledger-tax-info.component';
import AccountLedgerBankAccountComponent from './account-ledger-bank-account.component';
import AccountLedgerTranscations from './account-ledger-transactions.component';
import { AddressContainer } from '../../../../../../common/address/containers/address.container';

export const AccountLedgerComponent = ({
    selectedAccountLedgers, handleInnerFormChange, selectedAddress, handleInnerBasicFormChange,
    handleFormSubmit, back, accountCategoriesList, id
}: any) => {

    const tabItems = [
        {
            id: 1,
            title: 'User Information',
            component: <AccountLedgerBasicInfoComponent
                handleInnerBasicFormChange={handleInnerBasicFormChange}
                selectedAccountLedgers={selectedAccountLedgers}
                accountCategoriesList={accountCategoriesList}
            />,
            isVisible: true,
        },
        {
            id: 2,
            title: 'Mailing Address',
            component: <AddressContainer
                handleInnerFormChange={handleInnerFormChange}
                selectedAddress={selectedAddress}
            />,
            isVisible: true,
        },
        {
            id: 3,
            title: 'Tax Registration',
            component: <AccountLedgerTaxInfoComponent
                onInnerFormChange={handleInnerFormChange}
                selectedAccountLedgers={selectedAccountLedgers}
            />,
            isVisible: true,
        },
        {
            id: 4,
            title: 'Bank Account',
            component: <AccountLedgerBankAccountComponent
                handleInnerFormChange={handleInnerFormChange}
                selectedAccountLedgers={selectedAccountLedgers}
            />,
            isVisible: id > 0 ? true : false,
        },
        {
            id: 5,
            title: 'Transactions',
            component: <AccountLedgerTranscations id={id}/>,
            isVisible: id > 0 ? true : false,
        },
    ]

    return (
        <div className="flex flex-col items-center w-full px-5 overflow-auto h-screen">

            <TabContainer tabItems={tabItems} />

            <div className='flex w-full justify-end items-end'>
                <button
                    onClick={back}
                    type='button'
                    className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
                >
                    Back
                </button>
                <button
                    className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
                    onClick={handleFormSubmit}

                    type="submit"
                >
                    Save
                </button>
            </div>
        </div>
    );
};

export default AccountLedgerComponent;